// extracted by mini-css-extract-plugin
module.exports = {"MainHeader":"Header_MainHeader__xO-fE","Wrapper":"Header_Wrapper__1yyVP","DesktopOnly":"Header_DesktopOnly__2nbYy"};